import { createSlice } from "@reduxjs/toolkit";
// import { getLocalStorageItem } from "../Utils";

const initialState = {
  // RECHARGE STATES
  token:"",
  profileDetail: {},
  walletBal: "",
  memberServices: [],
  personalDetail: {},
  merchantDetail: {},
  bankDetail: {},
  documents: {},
};

export const b2bSlice = createSlice({
  name: "B2B",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setProfile: (state, action) => {
      state.profileDetail = action.payload;
    },
    setWalletBal: (state, action) => {
      state.walletBal = action.payload;
    },
    setMemberService: (state, action) => {
      const map = action.payload.map((i) => i.service_id);
      state.memberServices = map;
    },
    setPersonalDetail: (state, action) => {
      state.personalDetail = action.payload;
    },
    setMerchantDetail: (state, action) => {
      state.merchantDetail = action.payload;
    },
    setBankDetail: (state, action) => {
      state.bankDetail = action.payload;
    },
    setDocuments: (state, action) => {
      state.documents = action.payload;
    },
    clearOnboardDetail: (state) => {
      state.personalDetail = {};
      state.merchantDetail = {};
      state.bankDetail = {};
      state.documents = {};
    },
    clearAllRedux: (state) => {
      state.personalDetail = {};
      state.merchantDetail = {};
      state.bankDetail = {};
      state.documents = {};
      state.heading = "Dashboard";
      state.subHeading = "";
      state.selectedTab = "";
      state.profileDetail = {};
      state.walletBal = "";
      state.memberServices = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setHeadings,
  setProfile,
  setselectedTab,
  setWalletBal,
  setSubHeadings,setToken,
  setMemberService,
  setPersonalDetail,
  setMerchantDetail,
  setBankDetail,
  clearOnboardDetail,
  setDocuments,clearAllRedux
} = b2bSlice.actions;

export default b2bSlice.reducer;
